
export const convertStringToIdName = (str) => {
  if (!str || typeof str !== "string") return {};
  const parts = str.split("|");
  if (parts.length !== 2) return {};
  return {
    id: Number(parts[0].trim()),
    name: parts[1].trim()
  };
};

export const parseStringToArrayVL = (input) => {
  if (!input || typeof input !== "string") return [];
  return input.split(',').map(item => {
    const [value, rawLabel] = item.split('|').map(str => str.trim());
    return {
      value: value,
      label: rawLabel
    };
  });
};

// Keep for backup
// function setDefaultServices(formik, str) {
//   if (!str || typeof str !== "string") return;
//   const arrays = str.split(/\s*,\s*/).map(item => {
//     const parts = item.split("|").map(part => part.trim());
//     if (parts.length !== 2 || !parts[0] || !parts[1]) return null; // Ensure valid format
//     return { value: parts[0], label: parts[1] };
//   }).filter(Boolean);
//   if (arrays.length > 0) {
//     formik.setFieldValue("defaultService", arrays);
//   }
// }